import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shipstation-orders-details',
  templateUrl: './shipstation-orders-details.component.html',
  styleUrls: ['./shipstation-orders-details.component.css']
})
export class ShipstationOrdersDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
